import React, { useState } from "react";
import { Mail, MessageSquare, Smartphone, Clock, CheckCircle } from 'lucide-react';
import NotificationViewModal from "./NotificationViewModal";

const channelIconMap = {
    email: <Mail size={16} className="text-blue-500" />,
    sms: <MessageSquare size={16} className="text-green-500" />,
    'App Push': <Smartphone size={16} className="text-purple-500" />,
    'app': <Smartphone size={16} className="text-purple-500" />,
    'push': <Smartphone size={16} className="text-purple-500" />,
};

const statusIconMap = {
    Sent: <CheckCircle size={16} className="text-brand-green" />,
    Scheduled: <Clock size={16} className="text-yellow-500" />,
};

const NotificationHistory = ({ notifications }) => {
    const [selectedNotif, setSelectedNotif] = useState(null);

    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 h-full">
            <h3 className="text-xl font-bold text-gray-800 font-display mb-4">History</h3>

            <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                {notifications.map((notif) => {
                    const platforms = notif?.platform
                        ?.split(',')
                        .map(p => p.trim())
                        .filter(Boolean);
                    return (
                        <div
                            key={notif.id}
                            className="p-4 rounded-lg bg-gray-50 border border-gray-200 hover:bg-gray-100 cursor-pointer transition"
                            onClick={() => setSelectedNotif(notif)}
                        >
                            <div className="flex justify-between items-start">
                                <p className="font-semibold text-gray-800">{notif?.title}</p>
                            </div>

                            {/* Limit message to 2 lines */}
                            <p className="text-sm text-gray-800 line-clamp-2 overflow-hidden">
                                {notif?.message}
                            </p>

                            <p className="text-sm text-gray-500 mt-1">To: {notif.target_group}</p>

                            <div className="flex justify-between items-center mt-3">
                                <div className="flex items-center gap-2">
                                    {platforms?.map((p, i) => (
                                        <div
                                            key={i}
                                            title={p}
                                            className="p-1.5 bg-white rounded-full border"
                                        >
                                            {channelIconMap[p] ?? p}
                                        </div>
                                    ))}
                                </div>

                                <p className="text-xs text-gray-400">{notif.created_at}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
            <NotificationViewModal isOpen={!!selectedNotif} onClose={() => setSelectedNotif(null)} notificationData={selectedNotif} />

        </div>
    );
};


export default NotificationHistory;
